module.exports = __webpack_public_path__ + "assets/img/TabBar_Favorites.773a1023.svg";